import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface VitalSign {
  label: { en: string; de: string };
  value: string;
  unit?: string;
  color: string;
}

const generatePatientVitalsContent = (lang: 'en' | 'de'): string => {
  const isEnglish = lang === 'en';

  const vitals: VitalSign[] = [
    {
      label: { en: 'Heart Rate', de: 'Herzfrequenz' },
      value: '72',
      unit: 'bpm',
      color: '#434ce8',
    },
    {
      label: { en: 'Blood Pressure', de: 'Blutdruck' },
      value: '120/80',
      color: '#10b981',
    },
    {
      label: { en: 'Temperature', de: 'Temperatur' },
      value: '37.2',
      unit: '°C',
      color: '#f59e0b',
    },
    {
      label: { en: 'Oxygen Saturation', de: 'Sauerstoffsättigung' },
      value: '98',
      unit: '%',
      color: '#434ce8',
    },
  ];

  return `
    <div style="display: flex; flex-direction: column; height: 100%;">
      <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
        <div style="font-weight: 600; color: #282a32;">
          ${isEnglish ? 'Patient: Sarah Johnson' : 'Patient: Sarah Jäger'}
        </div>
        <div style="color: #10b981; font-weight: 500;">
          ${isEnglish ? 'Stable' : 'Stabil'}
        </div>
      </div>
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px;">
        ${vitals
          .map(
            vital => `
          <div style="background-color: #ecf3fe; padding: 12px; border-radius: 8px;">
            <div style="font-size: 0.85rem; color: #686b87;">
              ${vital.label[lang]}
            </div>
            <div style="font-size: 1.5rem; font-weight: 600; color: ${vital.color};">
              ${vital.value}${vital.unit ? `<span style="font-size: 0.85rem; font-weight: normal;"> ${vital.unit}</span>` : ''}
            </div>
          </div>`,
          )
          .join('')}
      </div>
      <div style="margin-top: 12px; background-color: #ecf3fe; padding: 12px; border-radius: 8px;">
        <div style="font-size: 0.85rem; color: #686b87; margin-bottom: 6px;">
          ${isEnglish ? 'Respiratory Rate' : 'Atemfrequenz'}
        </div>
        <div style="display: flex; align-items: center;">
          <div style="width: 70%; height: 40px; background-color: #e9ecf4; border-radius: 8px; overflow: hidden; position: relative;">
            <div style="position: absolute; height: 100%; width: 60%; background-color: #434ce8; border-radius: 8px;"></div>
          </div>
          <div style="margin-left: 12px; font-size: 1.2rem; font-weight: 600; color: #434ce8;">16</div>
        </div>
      </div>
    </div>`;
};

export const patientVitalsWidget: MultilingualWidgetConfig = {
  id: 'patient-vitals',
  translations: {
    en: {
      title: 'Patient Vitals Monitor',
      content: generatePatientVitalsContent('en'),
    },
    de: {
      title: 'Patientenvitalwerte-Monitor',
      content: generatePatientVitalsContent('de'),
    },
  },
  x: 2,
  y: 4,
  w: 2,
  h: 4,
};
